module.exports = __webpack_public_path__ + "static/media/linkedin.c9de5f52.svg";